"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoCompletions = void 0;
exports.autoCompletions = {
    findPropertiesOrPlaces: {
        method: 'get',
        path: '/auto-completions/properties-places',
        response: {},
    },
    findProperties: {
        method: 'get',
        path: '/auto-completions/properties',
        response: {},
    },
};
//# sourceMappingURL=auto-completions.api.js.map